const PEGA_PASSWORD_CLIENT_ID = import.meta.env
  .VITE_PEGA_PASSWORD_AUTH_CLIENT_ID;
const PEGA_PASSWORD_CLIENT_SECRET = import.meta.env
  .VITE_PEGA_PASSWORD_AUTH_CLIENT_SECRET;
const PEGA_DEV_PASSWORD_CLIENT_ID = import.meta.env
  .VITE_PEGA_DEV_PASSWORD_AUTH_CLIENT_ID;
const PEGA_DEV_PASSWORD_CLIENT_SECRET = import.meta.env
  .VITE_PEGA_DEV_PASSWORD_AUTH_CLIENT_SECRET;
const PEGA_SESSION_CLIENT_ID = import.meta.env.VITE_PEGA_SESSION_AUTH_CLIENT_ID;
const PEGA_SESSION_CLIENT_SECRET = import.meta.env
  .VITE_PEGA_SESSION_AUTH_CLIENT_SECRET;
const PEGA_APP_ALIAS = import.meta.env.VITE_PEGA_APP_ALIAS;
const PEGA_DEV_APP_ALIAS = import.meta.env.VITE_PEGA_DEV_APP_ALIAS;

const APP_ENV = import.meta.env.VITE_CUSTOM_ENV;

function shouldUseDevPasswordAuth(): boolean {
  const isDevOrNonprod = APP_ENV === "development" || APP_ENV === "nonprod";
  if (!isDevOrNonprod) {
    return false;
  }

  if (!PEGA_DEV_PASSWORD_CLIENT_ID || !PEGA_DEV_PASSWORD_CLIENT_SECRET) {
    return false;
  }

  const query = new URLSearchParams(window.location.search);
  return query.get("pegaDevAuth") === "1";
}

function getPegaAppAlias(): string {
  if (shouldUseDevPasswordAuth() && PEGA_DEV_APP_ALIAS) {
    return PEGA_DEV_APP_ALIAS;
  }
  return PEGA_APP_ALIAS;
}

function loadPegaCredentials(
  oneTimeToken?: string,
  embedOneTimeToken: string | null = null
) {
  switch (true) {
    case embedOneTimeToken !== null:
      return {
        clientId: PEGA_SESSION_CLIENT_ID,
        clientSecret: PEGA_SESSION_CLIENT_SECRET,
        identityToken: embedOneTimeToken,
      };
    case typeof oneTimeToken !== "undefined": {
      const useDevAuth = shouldUseDevPasswordAuth();
      return {
        clientId: useDevAuth
          ? PEGA_DEV_PASSWORD_CLIENT_ID
          : PEGA_PASSWORD_CLIENT_ID,
        clientSecret: useDevAuth
          ? PEGA_DEV_PASSWORD_CLIENT_SECRET
          : PEGA_PASSWORD_CLIENT_SECRET,
        identityToken: oneTimeToken,
      };
    }
    default:
      throw new Error(
        "Either oneTimeToken or embedOneTimeToken must be provided to load Pega credentials."
      );
  }
}

export { getPegaAppAlias, loadPegaCredentials };
